module.exports = __webpack_public_path__ + "536e73aaf1530ab89623de037f40345b.png";